module.exports = __webpack_public_path__ + "static/hero-115fd5beb9662529dda2f7b499704ccc.jpg";